/*
 * Copyright (C) 2018 - 2026 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React from 'react';
import { Col, Form, Row, Select, Typography } from 'antd';
import styles from '../styles.module.css';

const { Text } = Typography;

function TariffSelectionCard({ t, form, tariffData, selectedTariff }) {
  return (
    <Row gutter={16} className={styles.tariffCard}>
      {/* Tariff Category */}
      <Col span={24}>
        <Row gutter={[16, 14]}>
          <Col xs={24} md={12}>
            <Text className={styles.fieldMainLabel}>
              {t('label_tariff_category')}
            </Text>
            <Form.Item
              className={styles.formItemNew}
              name="tariffCode"
              rules={[
                {
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.reject(
                        <div className={styles.marginTop10}>
                          {t('validation_required')}
                        </div>,
                      );
                    }

                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select category"
                size="default"
                className={styles.width100}
                popupClassName={styles.tariffDropdown}
                options={tariffData?.map((opt) => ({
                  label: opt.displayName,
                  value: opt.tariffCode,
                }))}
                optionFilterProp="label"
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>
          </Col>

          {/* Generation Tariff */}
          <Col xs={24} md={12}>
            <Text className={styles.fieldMainLabel}>
              {t('label_generation_tariffs')}
            </Text>

            <Form.Item
              className={styles.formItemNew}
              name="genTariffCode"
              rules={[
                {
                  validator: (_, value) => {
                    const isDisabled =
                      !selectedTariff ||
                      selectedTariff.genTariffs?.length === 0;
                    if (isDisabled) return Promise.resolve();

                    if (!value) {
                      return Promise.reject(
                        <div className={styles.marginTop10}>
                          {t('label_please_select_generation_tariff')}
                        </div>,
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Select
                showSearch
                placeholder="None"
                size="default"
                className={styles.width100}
                popupClassName={styles.tariffDropdown}
                disabled={
                  !selectedTariff || selectedTariff.genTariffs?.length === 0
                }
                options={
                  selectedTariff?.genTariffs?.map((tariff) => ({
                    label: `${tariff.displayName} (${tariff.code})`,
                    value: tariff.code,
                  })) || []
                }
                optionFilterProp="label"
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default TariffSelectionCard;
